import HorizontalListView from "../../../_utils/horizontal-list-view/HorizontalListView";
import {useContext} from "react";
import QRCodeStyleViewContext from "../../../QRCodeStyleViewContext";
// import QRCodeIconContext from "../../../../../../../../contexts/qr-code/icon/QRCodeIconContext";
// import ListItem from "../../more/icon/list-item/ListItem";

function IconComponent() {
    /**
     * Set active view from QRCodeStyleViewContext
     * @author Kacper Faber
     * @since 0.1.9
     */
    const {setActiveView} = useContext(QRCodeStyleViewContext);
    // const iconContext = useContext(QRCodeIconContext);

    const onMoreButtonClick = () => {
        setActiveView('more-icons');
    };

    return (
        <div>
            <HorizontalListView
                label="Ikony"
                moreButton="Więcej ikon"
                onMoreButtonClick={onMoreButtonClick}
            />
        </div>
    );
}

export default IconComponent;